import { useReceiptStore } from "@elixir/stores";
import { ReceiptInputFieldUi } from "ui";

function PaymentIdInputField() {
  const paymentId = useReceiptStore((state) => state.paymentId);
  const setPaymentId = useReceiptStore((state) => state.setPaymentId);

  return (
    <ReceiptInputFieldUi
      label="Payment ID"
      onChange={(val) => {
        setPaymentId(val.target.value);
      }}
      value={paymentId}
      placeholder="Enter Payment ID (Optional)"
    />
  );
}

export default PaymentIdInputField;
